<vex-page-layout>
  <vex-page-layout-content class="-mt-6">
    <div class="card">
      <div class="bg-app-bar px-6 h-16 border-b left-0 flex items-center">
        <h2
          class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
          <!-- <span *ngIf="dataSource?.data?.length == 1">{{
            "Sales Quotation.TEXT" | translate
          }}</span> -->
          <span>{{
            "SALES_QUOTATIONS.TEXT" | translate
          }}</span>
        </h2>

        <div
          class="rounded border border-black px-4 flex-auto flex items-center mat-table-search-input">
          <mat-icon
            class="icon-sm text-secondary"
            svgIcon="mat:search"></mat-icon>
          <input
            [formControl]="searchCtrl"
            class="px-4 py-2 border-0 outline-none w-full bg-transparent"
            [placeholder]="'SEARCH.TEXT' | translate"
            type="search"
            (input)="onKeyup($event)" />
        </div>

        <span class="flex-1"></span>
        <span class="flex-1"></span>
        <span class="flex-1"></span>

        <button
          [matMenuTriggerFor]="columnFilterMenu"
          class="ml-4 flex-none"
          mat-icon-button
          [matTooltip]="'FILTER_COLUMNS.TEXT' | translate"
          type="button">
          <mat-icon svgIcon="mat:filter_list"></mat-icon>
        </button>

        <button
          *ngIf="canAdd"
          (click)="createSalesQuotation()"
          class="ml-4 flex-none"
          color="primary"
          mat-mini-fab
          [matTooltip]="'ADD_SALES_QUOTATION.TEXT' | translate"
          type="button">
          <mat-icon svgIcon="mat:add"></mat-icon>
        </button>
      </div>

      <mat-progress-bar
        mode="indeterminate"
        *ngIf="isLoading"></mat-progress-bar>

      <div class="table-container">
        <table
          [dataSource]="dataSource"
          class="mat-elevation-z8 mat-table-fixed"
          mat-table
          matSort>
          <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

          <!-- Checkbox Column -->
          <ng-container matColumnDef="checkbox">
            <th *matHeaderCellDef mat-header-cell class="text-center">
              <!-- <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            color="primary">
              </mat-checkbox> -->
            </th>
            <td *matCellDef="let row" class="w-4" mat-cell ></td>
          </ng-container>

          <!-- Text Columns -->
         

          <ng-container matColumnDef="status" class="text-center">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="text-center">{{'STATUS.TEXT'|translate}}</th>
            <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
              <div
              *ngIf="getStatusClasses(SalesQuotationStatus[row.status]) as classes" [ngClass]="[classes.textClass, classes.bgClass]"         
              class="status-badge">
              {{ row.status | translate }}

              <!-- <button
                  *ngIf="SalesQuotationStatus[row.status] == SalesQuotationStatus.RejectedByCustomer.toString()"
                    class="hover:bg-hover cursor-pointer"
                    type="button"
                    matTooltip="{{row.customerNote}}">
                    <mat-icon id="grayIcon" svgIcon="mat:note"></mat-icon>
                  </button> -->
            </div>
            </td>
            </ng-container>

          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="text-center"> 
              {{ "ACTIONS.TEXT" | translate }}
            </th>
            <td *matCellDef="let row" class="w-10 text-secondary " mat-cell>
              <div class="action-icons">

                <button
                  class="hover:bg-hover cursor-pointer"
                  (click)="reviewRow(row)"
                  type="button"
                  matTooltip="{{ 'VIEW_DETAILS.TEXT' | translate }}">
                  <mat-icon id="grayIcon" svgIcon="mat:remove_red_eye"></mat-icon>
                </button>

                <button
                  *ngIf="
                    (SalesQuotationStatus[row.status] == SalesQuotationStatus.Draft.toString() ||
                    SalesQuotationStatus[row.status] == SalesQuotationStatus.WaitingCustomerAcceptance.toString() ||
                    SalesQuotationStatus[row.status] == SalesQuotationStatus.RejectedByCustomer.toString())&&canEdit
                  "
                  class="hover:bg-hover cursor-pointer"
                  id="grayIcon"
                  (click)="updateSalesQuotation(row)"
                  type="button"
                  matTooltip="{{ 'EDIT.TEXT' | translate }}">
                  <mat-icon svgIcon="mat:edit"></mat-icon>
                </button>

                <button
                *ngIf="
                (SalesQuotationStatus[row.status] == SalesQuotationStatus.WaitingCustomerAcceptance.toString() ||
                SalesQuotationStatus[row.status] == SalesQuotationStatus.RejectedByCustomer.toString())&&canAdd
              "
                  class="hover:bg-hover cursor-pointer"
                  (click)="copySelectedRow(row)"
                  type="button"
                  matTooltip="{{ 'COPY.TEXT' | translate }}">
                  <mat-icon id="grayIcon" svgIcon="mat:file_copy"></mat-icon>
                </button>

                <button
                *ngIf="
                (SalesQuotationStatus[row.status] == SalesQuotationStatus.Draft.toString() ||
                SalesQuotationStatus[row.status] == SalesQuotationStatus.WaitingCustomerAcceptance.toString() ||
                SalesQuotationStatus[row.status] == SalesQuotationStatus.RejectedByCustomer.toString())&&canDelete
              "
                  class="hover:bg-hover cursor-pointer"
                  (click)="deleteSalesQuotation(row)"
                  type="button"
                  matTooltip="{{ 'DELETE.TEXT' | translate }}">
                  <mat-icon id="grayIcon" svgIcon="mat:delete"></mat-icon>
                </button>

                

              </div>
            </td>
          </ng-container>
          <ng-container
          *ngFor="let column of columns; trackBy: trackByProperty">
          <ng-container
            *ngIf="column.type === 'text' && column.property != 'status'"
            [matColumnDef]="column.property">
            <th
              *matHeaderCellDef
              class="uppercase text-center"
              mat-header-cell
              mat-sort-header>
              {{ column.label | translate }}

            </th>
            <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
              {{ row[column.property] }}
            </td>
          </ng-container>
        </ng-container>
          <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
          <tr
            *matRowDef="let row; columns: visibleColumns"
            class="hover:bg-hover trans-ease-out cursor-pointer"
            mat-row></tr>
        </table>
      </div>
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [length]="totalRows"
        [pageIndex]="currentPage"
        (page)="pageChanged($event)"
        class="sticky left-0"></mat-paginator>
    </div>
  </vex-page-layout-content>
</vex-page-layout>
<div [ngClass]="{ rtl: isRtl }">
  <mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
    <div class="scroll-container">
      <button
        (click)="toggleColumnVisibility(column, $event)"
        *ngFor="let column of columns"
        class="checkbox-item mat-menu-item">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          [(ngModel)]="column.visible"
          color="primary">
          {{ column.label }}
        </mat-checkbox>
      </button>
    </div>
  </mat-menu>
</div>
